import type { SeparatorProps } from '@base-ui/react';

import { Separator as BaseSeparator } from '@base-ui/react';

import { clsxs } from '~/styles/utils';

import { separatorOrientationStyles, separatorStyle, separatorTextStyle } from './Separator.css';

type Props = SeparatorProps & {
  orientation?: 'horizontal' | 'vertical';
  text?: string;
};

export const Separator = ({ orientation = 'horizontal', text, ...delegated }: Props) => {
  return (
    <BaseSeparator
      {...delegated}
      className={clsxs(separatorStyle, separatorOrientationStyles[orientation], delegated.className)}
      orientation={orientation}
    >
      {text && <span className={separatorTextStyle}>{text}</span>}
    </BaseSeparator>
  );
};
